import React from 'react';
import { usePolTranslation } from "v4/hooks/usePolTranslation";

export default function PennylaneConfirmCreate() {
    const { t } = usePolTranslation();

    return (
        <>
            <p>{t('pennylane_create_confirm_intro')}</p>
            <p>{t('pennylane_create_confirm_client')}</p>
        </>
    );
}
